import {useEffect, useRef, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {api} from '../lib/api';
import {tr, subscribeContentLang, getContentLang} from '../lib/contentLang';
import {trackPageView, trackViewItem} from '../lib/marketing';
import {applySeoHead, fetchSeoHead} from '../lib/seoHead';

let visitor;
function visitorId(){
  if(visitor)return visitor;
  try{visitor=localStorage.getItem('asans_visitor');if(!visitor){visitor=crypto.randomUUID();localStorage.setItem('asans_visitor',visitor);}}
  catch{visitor=crypto.randomUUID();}
  return visitor;
}
export function track(kind,path,slug=''){
  // Automated browsers (QA runs, scrapers) are not visitors; the backend also drops bots by user agent.
  if(navigator.doNotTrack==='1'||navigator.webdriver)return;
  api('/events',{method:'POST',body:JSON.stringify({event_id:crypto.randomUUID(),visitor_id:visitorId(),kind,path,product_slug:slug,referrer:document.referrer?new URL(document.referrer).origin:''})}).catch(()=>{});
}

// Titles shown only while the server head is loading or unreachable. They never decide robots,
// 404 or structured data: the local catalog can be partial (first 100 products) or still loading.
const LOCAL_TITLES={'/wishlist':'Обране — ASANS','/compare':'Порівняння — ASANS','/':'LED дзеркало з підсвіткою купити | Інтернет-магазин ASANS','/shop':'Каталог — ASANS','/about':'Про компанію — ASANS','/shipping':'Доставка та оплата — ASANS','/warranty':'Гарантія та повернення — ASANS','/reviews':'Відгуки про ASANS','/cart':'Кошик — ASANS','/checkout':'Оформлення замовлення — ASANS','/sale':'SALE — знижки ASANS','/collections':'Колекції — ASANS','/journal':'Журнал — ASANS'};

function localTitle(pathname,data,slug){
  const product=slug&&data.products?.find(p=>p.slug===slug);
  if(product)return product.seo_title&&getContentLang()!=='ru'?product.seo_title:`${tr(product.title)} — ASANS`;
  const category=data.categories?.find(c=>pathname===`/category/${c.slug}`);
  if(category)return `${tr(category.name)} — ASANS`;
  return LOCAL_TITLES[pathname]?tr(LOCAL_TITLES[pathname]):'';
}

// Keeps <head> in sync with the current URL. The backend SEO head (GET /api/seo/head, the same
// payload the Netlify edge function injects on a direct load) is the single source of truth for
// title, description, canonical, robots, hreflang, OpenGraph and JSON-LD; it is re-applied after
// every SPA navigation and language switch, so nothing from the previous page is left behind.
export const StorefrontBridge=()=>{
  const {pathname}=useLocation();
  const [langTick,setLangTick]=useState(0);
  useEffect(()=>subscribeContentLang(()=>setLangTick(v=>v+1)),[]);
  const tracked=useRef('');
  const request=useRef(0);
  useEffect(()=>{
    const firstView=tracked.current!==pathname;
    tracked.current=pathname;
    if(firstView)track('page_view',pathname);
    const data=window.__ASANS_DATA__||{};
    let slug='';
    if(pathname.startsWith('/product/')){try{slug=decodeURIComponent(pathname.split('/')[2]||'');}catch{slug=pathname.split('/')[2]||'';}}
    const lang=getContentLang()==='ru'?'ru':'uk';
    const id=++request.current;
    const quick=localTitle(pathname,data,slug);
    if(quick)document.title=quick;
    const reportView=(product,exists)=>{
      if(!firstView)return;
      trackPageView(pathname,document.title);
      if(slug&&exists){track('product_view',pathname,slug);if(product)trackViewItem(product);}
    };
    fetchSeoHead(pathname,lang).then(seo=>{
      if(id!==request.current)return;
      applySeoHead(document,seo);
      reportView(data.products?.find(p=>p.slug===slug)||seo.item,seo.status===200);
    }).catch(()=>{
      if(id!==request.current)return;
      // Head endpoint unreachable: never add noindex (a real page must not be de-indexed by a
      // network error); point canonical at this URL and drop tags that describe another page.
      const site=String(data.site_url||window.location.origin).replace(/\/$/,'');
      const href=site+pathname+(lang==='ru'?'?lang=ru':'');
      let canonical=document.querySelector('link[rel="canonical"]');
      if(canonical&&canonical.href!==href)document.querySelectorAll('script[type="application/ld+json"],link[rel="alternate"][hreflang]').forEach(node=>node.remove());
      if(!canonical){canonical=document.createElement('link');canonical.rel='canonical';document.head.appendChild(canonical);}
      canonical.href=href;
      const product=slug&&data.products?.find(p=>p.slug===slug);
      reportView(product,Boolean(product));
    });
    const onClick=event=>{const target=event.target.closest('a,button');if(!target)return;if(target.href&&/^(tel:|mailto:|viber:)|t\.me\/|wa\.me\//.test(target.getAttribute('href')))track('contact_click',pathname);if(target.matches('.pdp-add,.pc-add,.uc-add')||target.textContent?.trim()==='Додати в кошик')track('add_to_cart',pathname,slug);};
    document.addEventListener('click',onClick);
    return()=>document.removeEventListener('click',onClick);
  },[pathname,langTick]);
  return null;
};
